// Dates for the customer account pages (M6): "27 Sep 2026", the same shape
// as LabelMockup#title's strftime("%-d %b %Y").
//
// Deterministic on purpose: the month names are fixed (en-GB's Intl short
// month is "Sept" in current ICU data), and timestamps are read in the
// business's own time zone, Europe/London, so the SSR render in Node and the
// hydrating browser always print the same day.

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

const LONDON = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/London",
  day: "numeric",
  month: "numeric",
  year: "numeric",
})

/** An ISO 8601 timestamp as its London calendar day: "27 Sep 2026". */
export function formatDay(iso: string) {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ""
  const parts = Object.fromEntries(LONDON.formatToParts(date).map((part) => [part.type, part.value]))
  return `${Number(parts.day)} ${MONTHS[Number(parts.month) - 1]} ${parts.year}`
}

/** A calendar date ("2027-06-12", no time or zone) as "12 Jun 2027". */
export function formatDateOnly(ymd: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd)
  if (!match) return ymd
  const [, year, month, day] = match
  return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}`
}

const LONDON_TIME = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/London",
  day: "numeric",
  month: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
})

/** An ISO 8601 timestamp as its London day and time: "27 Sep 2026, 14:05" (admin, M7). */
export function formatDayTime(iso: string) {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ""
  const parts = Object.fromEntries(LONDON_TIME.formatToParts(date).map((part) => [part.type, part.value]))
  return `${Number(parts.day)} ${MONTHS[Number(parts.month) - 1]} ${parts.year}, ${parts.hour}:${parts.minute}`
}
